import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=guest, object=user
  const [ready, setReady] = useState(false);

  const refresh = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (err) {
      // 401 é esperado para visitante; qualquer outro erro fica em log para debug.
      if (err?.response?.status !== 401) {
        console.error("[auth] refresh error:", err);
      }
      setUser(false);
    } finally {
      setReady(true);
    }
  };

  // Bootstrap once on mount — intencional single-run.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { refresh(); }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    await refresh();
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (err) {
      console.error("[auth] logout error (ignorado, sessão local será limpa):", err);
    }
    setUser(false);
  };

  const value = useMemo(
    () => ({ user, ready, login, logout, refresh }),
    // login/logout/refresh são closures estáveis dentro deste provider e não precisam ser dependências
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [user, ready]
  );

  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
